import logger from '../utils/logger';

// TODO: Replace with actual backend API URL when available
const CONTACT_API_URL = (
  process.env.REACT_APP_API_URL || 'https://rx2p5fu5wa.execute-api.us-east-1.amazonaws.com/dev'
).replace(/\/$/, '');

/**
 * Sends a message from the Contact Us form to the backend.
 * Uses a custom API Key to prevent unauthorized automated bot spam without requiring Cognito auth.
 */
export async function sendContactMessage(
  name: string,
  email: string,
  message: string,
  attachments?: Array<{ content: string; name: string }>,
): Promise<boolean> {
  try {
    const payload = {
      name,
      email,
      message,
      attachments,
    };

    // The API URL will specifically hit the /public/contact unauthenticated endpoint
    const response = await fetch(`${CONTACT_API_URL}/public/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // This MUST match the Lambda's expected secret key validation to allow sending
        // In dev, if the env variable is missing, we use a fallback that should be configured in the backend
        'x-api-key':
          process.env.REACT_APP_CONTACT_API_SECRET || 'sk_contact_1905_random_number_lol_gs5_juve2',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Failed to send message: ${response.status}`);
    }

    logger.info('Contact Us', 'Successfully sent contact message');
    return true;
  } catch (error) {
    logger.error('Contact Us', 'Failed sending message', error as Error);
    return false;
  }
}
